import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./FreeVideosPage.css";

const FreeVideosPage = () => {
  const [videos, setVideos] = useState([]);
  const [playingVideoId, setPlayingVideoId] = useState(null); // Track playing video
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("paidUser") ||
                       localStorage.getItem("creatorUser") ||
                       localStorage.getItem("adminUser");

    if (storedUser) setUser(JSON.parse(storedUser));

    const fetchFreeVideos = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/videos/free`);
    console.log("Free videos API response:", res.data);
    setVideos(Array.isArray(res.data) ? res.data : res.data.videos || []);
  } catch (err) {
    console.error("Error fetching free videos:", err);
    setVideos([]); // ensure videos is always an array
  }
};


    fetchFreeVideos();
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/");
  };

  const handlePlayClick = (videoId) => {
    setPlayingVideoId(videoId);
  };

  return (
    <div className="free-videos-page">
      <header className="free-header">
        <h2 className="logo" onClick={() => navigate("/")}>Nitinshukla</h2>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/free-videos" className="active">Free Videos</Link>
          {user && <Link to="/profile">Profile</Link>}
          {user ? (
            <button onClick={handleLogout}>Logout</button>
          ) : (
            <Link to="/">Login</Link>
          )}
        </nav>
      </header>

      <div className="free-videos-container">
        <h2>Featured Videos</h2>
        <div className="video-grid">
          {videos.length === 0 ? (
            <p>No free videos available right now.</p>
          ) : (
            videos.map((video) => (
              <div key={video._id} className="video-card">
                <h4>{video.title}</h4>

                {playingVideoId === video._id ? (
                  // Show video player when playing
                  <video width="300" controls autoPlay>
                    <source
                      src={`${process.env.REACT_APP_API_URL}${video.videoUrl}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  // Show thumbnail with play button overlay
                  <div
                    className="video-thumbnail-wrapper"
                    onClick={() => handlePlayClick(video._id)}
                  >
                    {video.thumbnail && (
                      <img
                        src={`${process.env.REACT_APP_API_URL}${video.thumbnail}`}
                        alt={video.title}
                        className="video-thumb"
                      />
                    )}
                    <div className="play-button-overlay">▶️</div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      <section className="footer-home">
        <h6>© 2025 Nitin Shukla. All rights reserved.</h6>
        
      </section>
    </div>
  );
};

export default FreeVideosPage;
